import $http from '@/services/common/http.service';
import jwtService from '@/services/common/jwt.service';

export class ReportService {
  public async loadReport(data?: {
    companyName?: string;
    fromDate?: string;
    toDate?: string;
    department?: string;
  }) {
    const user = await jwtService.getUser();
    const response = await $http.query(
      `admins/${user.id}/reports/overall`,
      data
    );
    return response.data.data as [];
  }

  public async loadIndividuals(data: {
    coachId?: string;
    fromDate?: string;
    toDate?: string;
  }) {
    const user = await jwtService.getUser();
    const response = await $http.query(
      `admins/${user.id}/reports/individual`,
      data
    );
    return response.data.data;
  }
}

const reportService = new ReportService();
export default reportService;
